import 'src/utils/polyfills';

import invariant from 'invariant';
import React from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import {Provider} from 'react-redux';

import {bootstrapStores} from 'src/client/bootstrap';
import FluxRoot from 'src/flux/root';
import ErrorBoundary from 'src/components/500/boundary';
import SurveyApp from 'src/components/survey/app';


const match = /^\/survey\/([^\/]+)/.exec(window.location.pathname);
const sentEventId = match && match[1];

invariant(sentEventId, 'Could not render without a sentEventId.');

const {reduxStore, store, env} = bootstrapStores();
const appElement = document.getElementById('app');

invariant(appElement, 'Could not render without an #app.');

const root =
  env.query.render_mode === 'client'
    ? createRoot(appElement)
    : // @ts-expect-error - TS2554 - Expected 2-3 arguments, but got 1.
      hydrateRoot(appElement);
root?.render(
  <ErrorBoundary>
    <SurveyApp
      sentEventId={sentEventId}
      reduxStore={reduxStore}
      senseStore={store}
    />
  </ErrorBoundary>,
);
